import { GetFileExtension, getJwt, imageFormats } from '@app/helpers';
import Axios from 'axios';
import api from '../api';
import { wiewArquivoAnexo, downloadAnexo } from '@app/api/apiAnexo';

export interface sasFornecedorAvaliacaoConfide {
  id: string;
  sasFornecedorId: string;
}

export interface sasFornecedorAvaliacaoConfideForm {
  id: string;
  sasFornecedorId: string;
  arquivo: any;
  dataValidade: Date;
  comentario: string;
}

export const getAllSasFornecedorAvaliacaoConfide = () =>
  api.get<sasFornecedorAvaliacaoConfide[]>('sasFornecedorAvaliacaoConfide');

export const getAllsasFornecedorAvaliacaoConfideByFornecedorId = (fornecedorId: string) =>
  api.get<sasFornecedorAvaliacaoConfide[]>(
    `sasFornecedorAvaliacaoConfide/getAllSasFornecedorAvaliacaoConfideByFornecedorId/${fornecedorId}`,
  );

export const createsasFornecedorAvaliacaoConfide = (
  fornecedorAvaliacaoConfideForm: sasFornecedorAvaliacaoConfideForm,
) => {
  const form = new FormData();
  form.append('arquivo', fornecedorAvaliacaoConfideForm['arquivo']);
  form.append('sasFornecedorId', fornecedorAvaliacaoConfideForm.sasFornecedorId);
  form.append('dataValidade', fornecedorAvaliacaoConfideForm.dataValidade);
  form.append('comentario', fornecedorAvaliacaoConfideForm.comentario);

  return api.post(`sasFornecedorAvaliacaoConfide/createSasFornecedorAvaliacaoConfide`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deletesasFornecedorAvaliacaoConfide = (id: string) =>
  api.delete(`sasFornecedorAvaliacaoConfide/${id}`);

export const wiewArquivoAnexoFornecedorAvaliacaoConfide = async (id: string, nomeDoArquivo: string) => {
  const url = '/api/sasFornecedorAvaliacaoConfide/downloadAnexo';
  await wiewArquivoAnexo(id, nomeDoArquivo, url);
};

export const downloadAnexoFornecedorAvaliacaoConfide = async (id: any, fileName: any) => {
  const url = '/api/sasFornecedorAvaliacaoConfide/downloadAnexo';
  await downloadAnexo(id, fileName, url);
};
